import type { BaseProduct } from '@bulknutrients/bulk-shared-lib/interfaces/Product';
import { getImageSrcUrl } from '@components/Media/Image/Image';
import { ProductCardVerticalVariant } from '@components/ProductCard/ProductCard';
import { EmblaCarousel } from './Carousel';

const createStructuredCarouselData = (products: BaseProduct[]) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  itemListElement: products.map((p, idx) => ({
    '@type': 'ListItem',
    position: idx + 1,
    item: {
      '@type': 'Product',
      name: p.name,
      image: p.images.map((img) => getImageSrcUrl({ image: img, width: 200 })),
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: p.averageRating,
        reviewCount: p.totalReviews,
      },
      url: `https://www.bulknutrients.com.au${p.slug}`,
      offers: {
        price: p.pricing.price.value,
        priceCurrency: 'AUD',
      },
    },
  })),
});

export function FPTProductsCarousel({
  relatedProducts,
}: {
  relatedProducts: BaseProduct[];
}) {
  if (!relatedProducts.length) {
    return <></>;
  }

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(createStructuredCarouselData(relatedProducts)),
        }}
      />
      <aside
        className="col-span-full bg-transparent pt-5"
        aria-label="Products Customers also purchased"
      >
        <div className="my-5 pl-2">
          <EmblaCarousel
            title="Customers also bought"
            slides={relatedProducts.map((item) => (
              <ProductCardVerticalVariant
                product={item}
                key={item.entityId}
                location="FPTProductsCarousel"
              />
            ))}
          />
        </div>
      </aside>
    </>
  );
}
